/**
 * This feature is used to debounce a function
 * 
 * @param {function} func
 * @param {number} delay
 * @returns {function}
 */

export default function debounce (func, delay) {
    let timeoutId;

    return function (...args) {
        const context = this;

        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => func.apply(context, args), delay);
    };
}

/**
 * Usage example
 * 
 * import debounce from 'utils/debounce';
 * 
 * window.addEventListener('mousewheel', () => {
 *    (debounce(function () {
 *      console.log('scroll');    
 *    }, 100)();
 * });
 */
